import '../../../ProductCard/ProductCard.scss';
import './Wrapper.scss';

import React, { useContext } from 'react';
import {
	useIsMediumAndAbove,
	useIsSmallOnly,
} from '../../../../hooks/mediaQueries';

import { Context } from '../../store/store';
import CustomCatLargeListViewContent from '../ListViewContent/CustomCatLargeListViewContent@default';
import LargeListViewContent from '../ListViewContent/LargeListViewContent@default';
import SmallListViewContent from '../ListViewContent/SmallListViewContent@default';
import TradingRangeFlag from '../../../ProductCard/TradingRangeFlag/TradingRangeFlag';
import classnames from 'classnames';
import { isProductInTradingRange } from '../../../../utilities/product-utilities';
import loadable from '@loadable/component';
import { useEventListener } from '../../../../hooks/useEventListener';
import { useSelector } from 'react-redux';

const RecommendationCarousel = loadable(() =>
	import('../../../ProductCard/RecommendationCarousel/RecommendationCarousel')
);

const Content = ({ index, product, tradingRangeInfo, isFeatured }) => {
	const {
		ListerAlternativeProductsEnabled,
		CustomCategoriesEnabled,
	} = useSelector((state) => state.experimentSwitches);

	const [state] = useContext(Context);
	const { loaded } = state;

	const isSmallOnly = useIsSmallOnly();
	const isMediumAndAbove = useIsMediumAndAbove();

	return (
		<>
			<div className="flex">
				<meta itemProp="position" content={index} />

				{isSmallOnly && (
					<SmallListViewContent {...{ product, tradingRangeInfo }} />
				)}

				{isMediumAndAbove && (
					<>
						{loaded && tradingRangeInfo && (
							<TradingRangeFlag
								{...tradingRangeInfo}
								isFeatured={isFeatured}
								enableHover
							/>
						)}

						{!CustomCategoriesEnabled && (
							<LargeListViewContent {...{ product }} />
						)}
						{CustomCategoriesEnabled && (
							<CustomCatLargeListViewContent {...{ product }} />
						)}
					</>
				)}
			</div>

			{ListerAlternativeProductsEnabled && product.State === 'OutOfStock' && (
				<RecommendationCarousel NowPrice={product.PricePodViewModel.NowPrice} />
			)}
		</>
	);
};
const Wrapper = ({ product, index, isFeatured }) => {
	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	const [state, dispatch] = useContext(Context);
	const { loaded } = state;

	useEventListener(`lazy-load-${product.ColourId}`, () => {
		dispatch({ type: 'UPDATE_LOADED', payload: true });
	});

	const tradingRangeInfo = isProductInTradingRange(product.Code);

	const props = {
		id: product.Code,
		className: classnames(
			'relative h-full w-full bg-white p-2 rounded-lg border-gray-30',
			{
				'my-2': !isFeatured,
				'border border-solid': loaded && !isFeatured,
				'pt-8': tradingRangeInfo,
				'wrapper--hover': CustomCategoriesEnabled && !isFeatured,
			}
		),
		itemProp: 'itemListElement',
		itemScope: true,
		itemType: 'http://schema.org/ListItem',
		['data-productcode']: product.Code,
		['data-testid']: 'product-card-list-view',
		['data-lazy-sku']: product.ColourId,
	};

	return React.createElement(
		isFeatured ? 'div' : 'li',
		props,
		<Content {...{ index, product, tradingRangeInfo, isFeatured }} />
	);
};

export default Wrapper;
